import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/TextLongLeft.tsx
const TextLongLeftIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M20 17a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2h16Zm-7.052-4a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2h8.948ZM20 9a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2h16Zm-7-4a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2h9Z",
		fill: props.fill || "currentColor"
	})
}));
export { TextLongLeftIcon };
